import type { Messages } from '../catalogue.en'

export const leads: Partial<Messages> = {
  'lead.title': 'לידים',
  'lead.subtitle': 'קליטת מטופל לפני שהרשומה הופכת לפעילה',
  'lead.tableLabel': 'לידים של מטופלים',
  'lead.loading': 'טוען לידים',
  'lead.loadFailed': 'לא ניתן לטעון את הלידים.',
  'lead.retry': 'ניסיון חוזר',
  'lead.empty': 'עדיין אין לידים',
  'lead.emptyDetail': 'צרו ליד כאשר מטופל חדש פונה לראשונה למרפאה.',
  'lead.publicEntryTitle': 'קליטת מטופלים ציבורית',
  'lead.publicEntryDetail': 'אפשר לשתף את הדף הכללי הזה עם מטופלים שנרשמים בעצמם.',
  'lead.publicEntryOpen': 'פתיחת הקליטה הציבורית',
  'lead.columnPatient': 'מטופל',
  'lead.columnCode': 'קוד ליד',
  'lead.columnContact': 'יצירת קשר',
  'lead.columnSource': 'מקור',
  'lead.columnEntry': 'דרך כניסה',
  'lead.columnAcquisition': 'שיוך הגעה',
  'lead.columnResponsible': 'אחראי',
  'lead.columnStatus': 'סטטוס',
  'lead.columnCreated': 'נוצר',
  'lead.columnExpires': 'תוקף הקישור',
  'lead.columnActions': 'פעולות',
  'lead.statusIssued': 'ממתין למטופל',
  'lead.statusSubmitted': 'נשלח',
  'lead.statusRevoked': 'בוטל',
  'lead.sourcePhone': 'טלפון',
  'lead.sourceEmail': 'דוא״ל',
  'lead.sourceMessenger': 'מסרון',
  'lead.sourceWebsite': 'אתר',
  'lead.sourceTelegram': 'Telegram',
  'lead.sourceReferral': 'הפניה',
  'lead.sourceOther': 'אחר',
  'lead.entryInvited': 'הזמנה פרטית',
  'lead.entryPublic': 'דף ציבורי',
  'lead.newTitle': 'ליד חדש',
  'lead.newDetail': 'יצירת מטופל זמני והנפקת קישור פרטי לקליטה.',
  'lead.language': 'שפה מועדפת',
  'lead.country': 'מדינת מגורים',
  'lead.source': 'ערוץ פנייה',
  'lead.comment': 'הערה קצרה',
  'lead.curator': 'רופא או מתאם אחראי',
  'lead.protocol': 'פרוטוקול קליטה',
  'lead.expiresAt': 'תוקף הקישור',
  'lead.create': 'יצירת ליד',
  'lead.creating': 'יוצר…',
  'lead.selectionRequired': 'יש לבחור אחראי ופרוטוקול קליטה.',
  'lead.expiryRequired': 'יש לבחור תוקף עתידי לקישור.',
  'lead.optionsLoading': 'טוען אחראים ופרוטוקולים…',
  'lead.optionsFailed': 'לא ניתן לטעון אחראים או פרוטוקולי קליטה.',
  'lead.noProtocols': 'אין פרוטוקול קליטת מטופל שפורסם.',
  'lead.saveFailed': 'לא ניתן ליצור את הליד.',
  'lead.idempotencyConflict': 'ניסיון היצירה הזה כבר שימש לנתוני ליד אחרים.',
  'lead.createdTitle': 'הליד נוצר',
  'lead.createdDetail': 'יש להעתיק כעת את הקישור הפרטי. Core אינו שומר את הקישור הגולמי.',
  'lead.link': 'קישור לקליטת המטופל',
  'lead.copyLink': 'העתקת קישור',
  'lead.linkCopied': 'הקישור הועתק',
  'lead.copyFailed': 'לא ניתן להעתיק את הקישור. יש לבחור ולהעתיק אותו ידנית.',
  'lead.openLink': 'פתיחת הקליטה',
  'lead.rotateNamed': 'הנפקת קישור חדש עבור {name}',
  'lead.claim': 'לקיחת ליד',
  'lead.claimNamed': 'לקיחת הליד של {name}',
  'lead.claiming': 'לוקח…',
  'lead.claimFailed': 'לא ניתן לקחת את הליד. ייתכן שהוא כבר שויך למישהו אחר.',
  'lead.claimSelected': 'לקיחת {count} שנבחרו',
  'lead.claimedCount': '{count} לידים נלקחו.',
  'lead.claimedBefore': 'לפני כן נלקחו {count} לידים.',
  'lead.rotateTitle': 'הנפקת קישור קליטה חדש',
  'lead.rotateDetail': 'הקישור הקודם יפסיק לפעול מיד.',
  'lead.rotate': 'הנפקת קישור חדש',
  'lead.rotating': 'מנפיק…',
  'lead.rotateFailed': 'לא ניתן להנפיק קישור חדש.',
  'lead.notRotatable': 'הליד הזה אינו ממתין עוד לקליטה.',
  'lead.discardTitle': 'למחוק את טיוטת הליד?',
  'lead.discardDetail': 'המידע שהוזן כאן עדיין לא נשמר.',
  'lead.keepEditing': 'להמשיך לערוך',
  'lead.discard': 'מחיקה',
  'lead.submissionsTitle': 'קליטת מטופל',
  'lead.submissionsDetail': 'ראיות קליטה שמקורן במטופל ונשמרו עם גרסת הפרוטוקול שמולאה.',
  'lead.submissionsLoading': 'טוען תשובות קליטה',
  'lead.submissionsFailed': 'לא ניתן לטעון את תשובות הקליטה.',
  'lead.submissionsEmpty': 'לא נרשמה תשובת קליטת מטופל.',
  'lead.answeredBy': 'נענה על ידי',
  'lead.authoredAt': 'נשלח',
  'lead.authorPatient': 'מטופל',
  'lead.authorRepresentative': 'נציג',
  'lead.schemaUnavailable': 'לקוח זה אינו יכול להציג את הפרוטוקול ההיסטורי.',
  'lead.valueYes': 'כן',
  'lead.valueNo': 'לא',
  'lead.representativesTitle': 'נציגים',
  'lead.representativesLoading': 'טוען נציגים',
  'lead.representativesFailed': 'לא ניתן לטעון נציגים.',
  'lead.representativesEmpty': 'לא נרשם נציג.',
  'lead.representativeParent': 'הורה',
  'lead.representativeGuardian': 'אפוטרופוס',
  'lead.representativeAuthorized': 'מיופה כוח',
  'lead.representativeOther': 'אחר',
  'lead.verificationSelfDeclared': 'הצהרה עצמית',
  'lead.verificationVerified': 'מאומת',
  'lead.verificationRevoked': 'בוטל',
  'lead.representativeRelationship': 'קשר:',
  'lead.authorityScope': 'הרשאה:',
  'lead.authoritySubmitOnboarding': 'שליחת קליטת מטופל',
  'lead.areaNavigation': 'מדורי לידים',
  'lead.sectionLeads': 'לידים',
  'lead.sectionLeadsDetail': 'פניות וקליטת מטופלים',
  'lead.sectionPartners': 'שותפי הפניה',
  'lead.sectionPartnersDetail': 'מקורות, קישורים ותגמולים',
  'referralPartner.title': 'שותפי הפניה',
  'referralPartner.subtitle': 'ישויות משפטיות הרשומות בתוכנית ההפניות של המרפאה',
  'referralPartner.loading': 'טוען שותפי הפניה',
  'referralPartner.loadFailed': 'לא ניתן לטעון שותפי הפניה.',
  'referralPartner.tableLabel': 'מרשם שותפי הפניה',
  'referralPartner.empty': 'עדיין אין שותפי הפניה',
  'referralPartner.emptyDetail': 'רשמו ישות משפטית קיימת כדי להנפיק קישור הפניה פרטי.',
  'referralPartner.columnName': 'שותף',
  'referralPartner.columnKind': 'סוג',
  'referralPartner.columnStatus': 'סטטוס',
  'referralPartner.columnValidity': 'תוקף',
  'referralPartner.columnAgreement': 'הסכם',
  'referralPartner.columnLink': 'קישור אישי',
  'referralPartner.columnVerified': 'לידים מאומתים',
  'referralPartner.columnCompleted': 'השלימו קליטה',
  'referralPartner.columnPoints': 'נקודות זמינות',
  'referralPartner.columnMoney': 'כסף מאושר',
  'referralPartner.columnActions': 'פעולות',
  'referralPartner.openNamed': 'פתיחת {name}',
  'referralPartner.kindOrganization': 'ארגון',
  'referralPartner.kindIndividual': 'יחיד',
  'referralPartner.status.active': 'פעיל',
  'referralPartner.status.suspended': 'מושהה',
  'referralPartner.status.closed': 'סגור',
  'referralPartner.panelEyebrow': 'שותף הפניה',
  'referralPartner.edit': 'עריכה',
  'referralPartner.editIdentity': 'עריכת זהות משפטית',
  'referralPartner.legalEntity': 'ישות משפטית',
  'referralPartner.selectLegalEntity': 'בחירת ישות משפטית',
  'referralPartner.identityManagedSeparately': 'שם, פרטי מס, כתובת ופרטי קשר נערכים במסך הישויות המשפטיות.',
  'referralPartner.archive': 'העברה לארכיון',
  'referralPartner.restore': 'שחזור',
  'referralPartner.contactTitle': 'פרטי ישות משפטית',
  'referralPartner.kind': 'סוג ישות משפטית',
  'referralPartner.taxId': 'מספר מס',
  'referralPartner.taxType': 'סוג מספר מס',
  'referralPartner.phone': 'טלפון',
  'referralPartner.email': 'דוא״ל',
  'referralPartner.website': 'אתר',
  'referralPartner.address': 'כתובת',
  'referralPartner.addressLine2': 'שורת כתובת שנייה',
  'referralPartner.city': 'עיר',
  'referralPartner.postalCode': 'מיקוד',
  'referralPartner.country': 'מדינה',
  'referralPartner.linkTitle': 'קישור הפניה פרטי',
  'referralPartner.link': 'קישור הפניה',
  'referralPartner.linkActive': 'פעיל',
  'referralPartner.linkInactive': 'בוטל או לא הונפק',
  'referralPartner.copyLink': 'העתקת קישור ההפניה',
  'referralPartner.openLink': 'פתיחת קישור ההפניה',
  'referralPartner.copied': 'קישור ההפניה הועתק.',
  'referralPartner.copyFailed': 'לא ניתן להעתיק את הקישור. נא לבחור ולהעתיק אותו ידנית.',
  'referralPartner.rotate': 'החלפת קישור',
  'referralPartner.revoke': 'ביטול קישור',
  'referralPartner.performanceTitle': 'שיוך ויתרות',
  'referralPartner.pointsAvailable': 'נקודות זמינות',
  'referralPartner.pointsPending': 'נקודות ממתינות',
  'referralPartner.pointsRedeemed': 'נקודות שמומשו',
  'referralPartner.pointsReversed': 'נקודות שבוטלו',
  'referralPartner.balancePending': 'ממתין',
  'referralPartner.balanceApproved': 'מאושר',
  'referralPartner.balancePaid': 'שולם',
  'referralPartner.balanceReversed': 'בוטל',
  'referralPartner.agreementsTitle': 'היסטוריית הסכמים',
  'referralPartner.agreementsEmpty': 'לא נרשם הסכם.',
  'referralPartner.agreementCode': 'קוד הסכם',
  'referralPartner.agreementStatus': 'סטטוס הסכם',
  'referralPartner.addAgreement': 'הוספת הסכם',
  'referralPartner.rulesTitle': 'כללי תגמול',
  'referralPartner.rulesEmpty': 'אין כלל תגמול פעיל.',
  'referralPartner.trigger.verified_lead': 'ליד מאומת',
  'referralPartner.trigger.onboarding_submitted': 'קליטה שהושלמה',
  'referralPartner.triggerLabel': 'אירוע',
  'referralPartner.valueKind': 'סוג תגמול',
  'referralPartner.valueKindPoints': 'נקודות',
  'referralPartner.valueKindMoney': 'כסף',
  'referralPartner.rewardPoints': 'נקודות: {amount}',
  'referralPartner.amount': 'סכום',
  'referralPartner.currency': 'מטבע',
  'referralPartner.effectiveFrom': 'בתוקף מתאריך ושעה',
  'referralPartner.effectiveTo': 'בתוקף עד תאריך ושעה',
  'referralPartner.ruleEnabled': 'פעיל',
  'referralPartner.ruleDisabled': 'מושבת',
  'referralPartner.editRule': 'עריכת כלל',
  'referralPartner.saveRule': 'שמירת גרסה חדשה',
  'referralPartner.addRule': 'הוספת כלל',
  'referralPartner.rewardsTitle': 'יומן תגמולים',
  'referralPartner.rewardsEmpty': 'עדיין לא נצברו תגמולים.',
  'referralPartner.rewardState.pending': 'ממתין',
  'referralPartner.rewardState.approved': 'מאושר',
  'referralPartner.rewardState.rejected': 'נדחה',
  'referralPartner.rewardState.paid': 'שולם',
  'referralPartner.rewardState.reversed': 'בוטל',
  'referralPartner.approve': 'אישור',
  'referralPartner.reject': 'דחייה',
  'referralPartner.markPaid': 'סימון כשולם',
  'referralPartner.reverse': 'ביטול',
  'referralPartner.failure.invalid': 'יש לבדוק את הערכים שהוזנו ולנסות שוב.',
  'referralPartner.failure.conflict': 'הרשומה השתנתה או שהפעולה אינה תקפה עוד. הנתונים העדכניים נטענו והערכים שהוזנו נשמרו.',
  'referralPartner.failure.forbidden': 'אין לך הרשאה לבצע פעולה זו.',
  'referralPartner.failure.unavailable': 'שירות ההפניות אינו זמין. אפשר לנסות שוב בלי לסגור את החלונית.',
  'referralPartner.editTitle': 'עריכת שותף הפניה',
  'referralPartner.createTitle': 'שותף הפניה חדש',
  'referralPartner.legalName': 'שם משפטי',
  'referralPartner.statusLabel': 'סטטוס התוכנית',
  'referralPartner.statusHistoryNote': 'השהיה או סגירה מפסיקות שיוכים חדשים. שיוכים קיימים והיסטוריית התגמולים נשמרים ללא שינוי.',
  'referralPartner.validFrom': 'תקף מתאריך',
  'referralPartner.validTo': 'תקף עד תאריך',
  'referralPartner.comment': 'הערה',
  'referralPartner.save': 'שמירה',
  'referralPartner.saving': 'שומר…',
  'referralPartner.cancel': 'ביטול',
  'referralPartner.confirm.archive': 'להעביר את שותף ההפניה לארכיון?',
  'referralPartner.confirm.restore': 'לשחזר את שותף ההפניה?',
  'referralPartner.confirm.rotate': 'להחליף את קישור ההפניה הפרטי?',
  'referralPartner.confirm.revoke': 'לבטל את קישור ההפניה הפרטי?',
  'referralPartner.confirm.reward': 'לאשר את שינוי התגמול?',
  'referralPartner.confirmDescription.archive': 'הקישור הפעיל יבוטל. שיוכים קיימים והיסטוריית התגמולים יישמרו.',
  'referralPartner.confirmDescription.restore': 'הנתונים ההיסטוריים יישמרו. לאחר השחזור יש להחליף קישור כדי להנפיק קישור פעיל חדש.',
  'referralPartner.confirmDescription.rotate': 'הקישור הנוכחי יפסיק לקבל שיוכים חדשים. שיוכים קיימים והיסטוריית התגמולים יישמרו.',
  'referralPartner.confirmDescription.revoke': 'הקישור יפסיק לקבל שיוכים חדשים. שיוכים קיימים והיסטוריית התגמולים יישמרו.',
  'referralPartner.confirmDescription.reward': 'יתווסף אירוע ליומן; היסטוריית התגמול הקודמת לא תיכתב מחדש.',
  'referralPartner.reason': 'סיבה',
  'referralPartner.confirm': 'אישור',
  'referralPartner.confirmedReason': 'אושר במרשם שותפי ההפניה.',
  'referralPartner.agreementState.active': 'פעיל',
  'referralPartner.agreementState.closed': 'סגור',
  'referralPartner.validityOpen': 'ללא הגבלה',
}
